// extracted by mini-css-extract-plugin
export var bodySections = "_d0-8";
export var gray = "_d0-7";
export var green = "_d0-4";
export var iconContainer = "_d0-9";
export var iconWidgetContainer = "_d0-1";
export var phoneIcon = "_d0-2";
export var red = "_d0-5";
export var statusDot = "_d0-3";
export var widgetContainer = "_d0-0";
export var yellow = "_d0-6";